// This file contains getters for AB test group values. Functions should be removed from here as AB tests finish.

import { getABTestGroup } from './shared/getABTestGroup';

export function getEnterFlowProgressValue() {
  return getABTestGroup('EnterFlowProgress');
}

export function getChooseYourPlanDec2025Value() {
  return getABTestGroup('ChooseYourPlanDec2025');
}

export function getHomePageHeroTextSep2025Value() {
  return getABTestGroup('HomePageHeroTextSep2025');
}

export function getAllPrizesPageTestValue() {
  return getABTestGroup('AllPrizesPage2026');
}
